const keywordsToRemove = [
  'INSTAGRAM_',
  'TIKTOK_',
  'YOUTUBE_',
  'BLOG_',
  'VIDEO_',
  'SHORT_',
  'LONG_'
];

export const processField = (field: string) => {
  // remove keyword from string
  const processed = keywordsToRemove.reduce(
    (acc, keyword) => (acc.startsWith(keyword) ? acc.replace(keyword, '') : acc),
    field
  );
  return processed.toLowerCase().replace(/_/g, ' ');
};

export function formatWords(words: string[]) {
  return words.map((word: string) => {
    let formattedWord = word.toLowerCase();

    formattedWord = formattedWord.replace(/_/g, ' ');

    formattedWord = formattedWord.charAt(0).toUpperCase() + formattedWord.slice(1);

    return formattedWord;
  });
}
